import { c as _c } from "react/compiler-runtime";
import { toMap } from '@newfront-insurance/core';
import { useMemo } from 'react';
import { useAccountManagers } from './use-account-managers';
import { useOperationsEmployees } from './use-operations-employees';
import { useProducers } from './use-producers';
import type { Employee } from '../../bff/types';
export interface NormalizedServicingTeams {
  accountManagersMap: Map<string, Employee>;
  producersMap: Map<string, Employee>;
  operationsEmployeesMap: Map<string, Employee>;
}
const mapEmployees = (employeeList: Employee[]): Map<string, Employee> => {
  return toMap(employeeList, employee => employee.userUuid);
};
interface EmployeesReturnProps {
  accountManagers: Employee[];
  producers: Employee[];
  operationsEmployees: Employee[];
}
export function useEmployees() {
  const $ = _c(10);
  const {
    data: accountManagers
  } = useAccountManagers();
  const {
    data: producers
  } = useProducers();
  const {
    data: operationsEmployees
  } = useOperationsEmployees();
  let t0;
  if ($[0] !== accountManagers) {
    t0 = accountManagers || [];
    $[0] = accountManagers;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== producers) {
    t1 = producers || [];
    $[2] = producers;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== operationsEmployees) {
    t2 = operationsEmployees || [];
    $[4] = operationsEmployees;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = {
      accountManagers: t0,
      producers: t1,
      operationsEmployees: t2
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
export function useEmployeesByUserUuid() {
  const $ = _c(10);
  const {
    accountManagers,
    producers,
    operationsEmployees
  } = useEmployees();
  let t0;
  let t1;
  if ($[0] !== accountManagers) {
    t1 = mapEmployees(accountManagers);
    $[0] = accountManagers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  const accountManagersMap = t0;
  let t2;
  let t3;
  if ($[2] !== producers) {
    t3 = mapEmployees(producers);
    $[2] = producers;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  t2 = t3;
  const producersMap = t2;
  let t4;
  let t5;
  if ($[4] !== operationsEmployees) {
    t5 = mapEmployees(operationsEmployees);
    $[4] = operationsEmployees;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  t4 = t5;
  const operationsEmployeesMap = t4;
  let t6;
  if ($[6] !== accountManagersMap || $[7] !== operationsEmployeesMap || $[8] !== producersMap) {
    t6 = {
      accountManagersMap,
      producersMap,
      operationsEmployeesMap
    };
    $[6] = accountManagersMap;
    $[7] = operationsEmployeesMap;
    $[8] = producersMap;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}